import { Component, OnInit, Input } from "@angular/core";
import {
    ContactMessage,
    ContactMessageService,
} from "./contact-message.service";
import { ToastrService } from "ngx-toastr"; // Inyecta ToastrService
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { SafeHtml } from "@angular/platform-browser";
import { ChangeDetectorRef } from "@angular/core";

@Component({
    selector: "app-contact-form",
    templateUrl: "./contact-form.html",
    styleUrls: ["./contact-form.scss"],
})
export class ContactFormComponent implements OnInit {
    private destroy$ = new Subject<void>();
    @Input() pb!: string;
    @Input() pt!: string;
    @Input() section!: string;
    @Input() title: string =
        "¿Tienes Algún Comentario Para Nosotros?, Contáctanos.";
    htmlEditorItems: any[] = [];

    //html editor
    sanitizedContent: SafeHtml = "";
    resetEditor = false;

    cssClass = "editor-300";
    shouldNotGroupWhenFull = false;
    htmlEditorMenuBarVisible = false;

    ngOnInit(): void {
        this.htmlEditorItems = [
            "undo",
            "redo",
            "|",
            "heading",
            "|",
            "indent",
            "outdent",
            "alignment",
            "|",
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "fontSize",
            "fontColor",
            "fontBackgroundColor",
            "highlight",
            "|",
            "bulletedList",
            "numberedList",
            "|",
            "link",
            "insertTable",
            "imageInsert",
            "|",
            "code",
            "blockQuote",
            "specialCharacters",
        ];
    }

    getContent(event: any) {
        this.sanitizedContent = event;
        this.isMessageInvalid();
    }

    messageStatus: boolean = false;
    isMessageInvalid(): boolean {
        if (this.resetEditor) {
            this.resetEditor = false;
            return false;
        }
        this.messageStatus = this.sanitizedContent == "";
        return this.messageStatus;
    }

    newMessage: ContactMessage = {
        name: "",
        email: "",
        phone: "",
        section: this.section,
        topic: "",
        message: "",
    };

    constructor(
        private contactMessageService: ContactMessageService,
        private toastr: ToastrService,
        private cdRef: ChangeDetectorRef
    ) {}

    addMessage(contactForm: any): void {
        this.newMessage.section = this.section;
        this.newMessage.message = this.sanitizedContent;
        this.contactMessageService
            .addContactMessage(this.newMessage)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    contactForm.resetForm();
                    this.resetEditor = true;
                    this.messageStatus = false;
                    this.cdRef.detectChanges();
                    this.toastr.success(
                        `<strong>¡Mensaje enviado!</strong><br>Gracias por contactarnos.`,
                        "",
                        { enableHtml: true }
                    );
                },
                error: (err) => {
                    if (err.status != 401) {
                        this.toastr.error(
                            `<strong>Error!</strong><br> No se pudo enviar el mensaje. Intenta nuevamente.`,
                            "",
                            { enableHtml: true }
                        );
                    }
                },
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
